<template>
  <a-drawer
    class="part drawer project-task"
    height="80%"
    title="New Task"
    placement="bottom"
    :closable="true"
    :visible="visible"
    :after-visible-change="afterVisibleChange"
    @close="onClose"
  >
    <div class="inner" v-if="project">
      <TaskForm :project="project._id" @submit="onSubmit" />
    </div>
    <!-- {{ project }} -->
  </a-drawer>
</template>
<script>
import TaskForm from '@/components/reno/forms/TaskForm.vue'

const KEY = 'CREATE_TASK'
export default {
  components: {
    TaskForm,
  },
  name: 'project-task-drawer',
  data() {
    return {}
  },
  computed: {
    project() {
      return this.$store.getters['pm/data']('project')
    },
    visible: {
      get() {
        return this.$store.getters['pm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('pm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    async onSubmit(valid_task) {
      if (valid_task) {
        await this.$store.dispatch('pm/createTask', valid_task)
      }
    },
    afterVisibleChange(val) {
      // NOTHING
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer.project-task {
  .inner {
    max-width: 700px;
    margin: 0 auto;
  }
}
</style>
